export default __webpack_public_path__ + "static/media/CurrencyExchangeRates@32.638bf23c.svg";